import * as request from '@/utils/request'

/**
 * 自动生成 api代码【模块名：快递绑定库位】
 * 生成日期：2024/05/30 11:55:52
 * 生成路径: src/api/express_take_over.js
 * 生成人：超级管理员
 * 需要在文件src/api/index.js 引入当前文件
 * import express_take_over from './express_take_over'
 * export default {
 * ...
 * // 快递绑定库位
 *    ...express_take_over,
 * }
 */

export default {
  /**
   * @description 获取列表
   * @param {*} data
   * @returns
   */
  getExpressTakeOverList(data) {
    return request.post('/express_take_over/list', data)
  },
  /**
   * @description 保存
   * @param {*} data
   * @returns
   */
  saveExpressTakeOver(data) {
    return request.post('/express_take_over/store', data)
  },
  /**
   * @description 获取详情
   * @param {*} id
   * @returns
   */
  getExpressTakeOverInfo(id) {
    let data = { id: id }
    return request.post('/express_take_over/get_info', data)
  },
  /**
   * @description 根据id删除单条信息
   * @param {*} data
   * @returns
   */
  deleteExpressTakeOver(id) {
    let data = { id: id }
    return request.post('/express_take_over/delete', data)
  },
  /**
   * 导出
   * @param data
   * @returns {Promise}
   */
  exportExpressTakeOvers(data) {
    return request.postBlob('/express_take_over/export', data)
  },

}